import ENDPOINTS from 'tradera-constants/endpoints';
import {
    axiosWithTokenRefresh,
    handleError,
    logError
} from 'tradera-utils/api';

export const getPersonalisedBrands = () => {
    return axiosWithTokenRefresh()
        .get(`${ENDPOINTS.PERSONALISED_SUGGESTIONS}/brands`)
        .catch(handleError())
        .catch(logError)
        .then(response => response?.data || []);
};

export const getPersonalisedSearches = () => {
    return axiosWithTokenRefresh()
        .get(`${ENDPOINTS.PERSONALISED_SUGGESTIONS}/searches`)
        .catch(handleError())
        .catch(logError)
        .then(response => response?.data || []);
};
